import { getToken } from '@/utils/auth'

// 路由懒加载，减少初始加载时间
const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: {
      requiresAuth: false,
      title: '登录'
    },
    alias: ['/signin', '/login-page']
  },
  {
    path: '/login-success',
    name: 'LoginSuccess',
    component: () => import('@/views/LoginSuccess.vue'),
    meta: {
      requiresAuth: false,
      title: '登录成功'
    }
  },
  {
    path: '/login-failed',
    name: 'LoginFailed',
    component: () => import('@/views/LoginFailed.vue'),
    meta: {
      requiresAuth: false,
      title: '登录失败'
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: {
      requiresAuth: false,
      title: '注册'
    }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/ForgotPassword.vue'),
    meta: {
      requiresAuth: false,
      title: '忘记密码'
    },
    alias: ['/forget-password']
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home/index.vue'),
    meta: {
      requiresAuth: false,
      title: '首页'
    }
  },
  {
    path: '/shop',
    name: 'Shop',
    component: () => import('@/views/Shop.vue'),
    meta: {
      requiresAuth: true,
      title: '商城'
    }
  },
  {
    path: '/shop/products',
    name: 'ProductList',
    component: () => import('@/views/shop/ProductList.vue'),
    meta: {
      requiresAuth: true,
      title: '商品列表'
    }
  },
  {
    path: '/shop/product/:id',
    name: 'ProductDetail',
    component: () => import('@/views/shop/ProductDetail.vue'),
    meta: {
      requiresAuth: true,
      title: '商品详情'
    }
  },
  {
    path: '/shop/cart',
    name: 'ShoppingCart',
    component: () => import('@/views/shop/ShoppingCart.vue'),
    meta: {
      requiresAuth: true,
      title: '购物车'
    }
  },
  {
    path: '/shop/orders',
    name: 'OrderList',
    component: () => import('@/views/shop/OrderList.vue'),
    meta: {
      requiresAuth: true,
      title: '我的订单'
    }
  },
  {
    path: '/shop/orders/:id',
    name: 'OrderDetail',
    component: () => import('@/views/shop/OrderDetail.vue'),
    meta: {
      requiresAuth: true,
      title: '订单详情'
    }
  },
  {
    path: '/message',
    name: 'Message',
    component: () => import('@/views/MessagePage.vue'),
    meta: {
      requiresAuth: true,
      title: '消息'
    }
  },
  {
    path: '/company',
    name: 'Company',
    component: () => import('@/views/Company.vue'),
    meta: {
      requiresAuth: true,
      title: '我的企业'
    }
  },
  {
    path: '/stats',
    name: 'Stats',
    component: () => import('@/views/StatsPage.vue'),
    meta: {
      requiresAuth: true,
      title: '统计'
    }
  },
  {
    path: '/user/:id',
    name: 'UserCard',
    component: () => import('@/views/UserCard.vue'),
    meta: {
      requiresAuth: true,
      title: '数字名片'
    }
  },
  {
    path: '/profile/:id',
    name: 'UserProfile',
    component: () => import('@/views/ProfilePage.vue'),
    meta: {
      requiresAuth: true,
      title: '用户资料'
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/ProfilePage.vue'),
    meta: {
      requiresAuth: true,
      title: '个人资料'
    }
  },
  {
    path: '/member',
    name: 'Member',
    component: () => import('@/views/Member.vue'),
    meta: {
      requiresAuth: true,
      title: '会员中心'
    }
  },
  {
    path: '/favorites',
    name: 'Favorites',
    component: () => import('@/views/Favorites.vue'),
    meta: {
      requiresAuth: true,
      title: '我的收藏'
    }
  },
  {
    path: '/relations',
    name: 'Relations',
    component: () => import('@/views/Relations.vue'),
    meta: {
      requiresAuth: true,
      title: '我的关系'
    }
  },
  {
    path: '/explore',
    name: 'Explore',
    component: () => import('@/views/Explore.vue'),
    meta: {
      requiresAuth: true,
      title: '探索用户'
    }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('@/views/Privacy.vue'),
    meta: {
      requiresAuth: true,
      title: '隐私设置'
    }
  },
  {
    path: '/security',
    name: 'Security',
    component: () => import('@/views/Security.vue'),
    meta: {
      requiresAuth: true,
      title: '账户安全'
    }
  },
  {
    path: '/notification',
    name: 'Notification',
    component: () => import('@/views/Notification.vue'),
    meta: {
      requiresAuth: true,
      title: '通知设置'
    }
  },
  {
    path: '/user-center',
    name: 'UserCenter',
    component: () => import('@/views/UserCenter.vue'),
    meta: {
      requiresAuth: true,
      title: '用户中心'
    }
  },
  {
    path: '/profile-edit',
    name: 'ProfileEdit',
    component: () => import('@/views/ProfileEdit.vue'),
    meta: {
      requiresAuth: true,
      title: '编辑资料'
    }
  },
  {
    path: '/chat/:friendId',
    name: 'Chat',
    component: () => import('@/views/ChatPage.vue'),
    meta: {
      requiresAuth: true,
      title: '聊天'
    }
  },
  {
    path: '/chat-list',
    name: 'ChatList',
    component: () => import('@/views/ChatList.vue'),
    meta: {
      requiresAuth: true,
      title: '聊天交友'
    }
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: () => import('@/views/ContactsPage.vue'),
    meta: {
      requiresAuth: true,
      title: '通讯录'
    }
  },
  {
    path: '/homepage',
    name: 'HomePage',
    component: () => import('@/views/HomePage.vue'),
    meta: {
      requiresAuth: true,
      title: '装修首页'
    }
  },
  { path: '/card-detail/:id', name: 'CardDetail', component: () => import('@/views/CardDetail.vue'), meta: { requiresAuth: true, title: '卡片详情' } },
  { path: '/card-list', name: 'CardList', component: () => import('@/views/CardList3D.vue'), meta: { requiresAuth: true, title: '名片列表' } },
  { path: '/nav-3d', name: 'Navigation3D', component: () => import('@/views/Navigation3D.vue'), meta: { requiresAuth: true, title: '3D导航' } },
  { path: '/certificate-apply', name: 'CertificateApply', component: () => import('@/views/CertificateApply.vue'), meta: { requiresAuth: true, title: '链上证书申请' } },
  { path: '/export-credential', name: 'ExportCredential', component: () => import('@/views/ExportCredential.vue'), meta: { requiresAuth: true, title: '导出凭证' } },
  { path: '/add-card', name: 'AddCard', component: () => import('@/views/AddCard.vue'), meta: { requiresAuth: true, title: '新增名片' } },
  { path: '/exchange-card', name: 'ExchangeCard', component: () => import('@/views/ExchangeCard.vue'), meta: { requiresAuth: true, title: '交换名片' } },
  { path: '/edit-card', redirect: '/card-list' },
  { path: '/edit-card/:id', name: 'EditCard', component: () => import('@/views/EditCard.vue'), meta: { requiresAuth: true, title: '编辑名片' } },
  { path: '/ai-agent', name: 'AIAgent', component: () => import('@/views/AIAgentPage.vue'), meta: { requiresAuth: true, title: 'AI智能体助手' } },
  { path: '/share-poster', name: 'SharePoster', component: () => import('@/views/SharePoster.vue'), meta: { requiresAuth: true, title: '转发海报' } },
  { path: '/app-market', name: 'AppMarket', component: () => import('@/views/AppMarket.vue'), meta: { requiresAuth: true, title: '应用市场' } },
  { path: '/opc-register', name: 'OpcRegister', component: () => import('@/views/OpcRegister.vue'), meta: { requiresAuth: true, title: '一人公司入驻' } },
  { path: '/opc-pricing', name: 'OpcPricing', component: () => import('@/views/OpcPricing.vue'), meta: { requiresAuth: true, title: 'OPC套餐' } },
  { path: '/companion-service', name: 'CompanionService', component: () => import('@/views/CompanionService.vue'), meta: { requiresAuth: true, title: 'AI陪伴服务' } },
  { path: '/companion-chat', name: 'CompanionChat', component: () => import('@/views/CompanionChat.vue'), meta: { requiresAuth: true, title: '陪伴对话' } },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: {
      requiresAuth: false,
      title: '页面不存在'
    }
  }
]

export default routes
